var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$ct("my-calendars")))]),
              _c("w-spacer"),
              _c(
                "w-dropdown",
                {
                  staticClass: "dropdown-options-button",
                  attrs: { items: _vm.menuItems, flat: "", right: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onEvent($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "bars" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }